import Vue from "vue";

const ras = {
  namespaced: true,
  state: {
    MAX_TIME: 3,
    MIX_TIME: 0.1,
    modes: { basic: "basic", hasTimeline: "none" },
    blocks: [],
    currentBlock: {},
    currentGroupIndex: 0,
    directMotors: {},
    servoMotors: {},
    history: [],
    selectedMotor: { key: "", type: "" },
    openedMotor: { key: "", type: "" },
    isDragging: false,
    DCMotorTypeOrderArr: ["EM2", "DC1", "DC2", "EM1"],
    SVMotorTypeOrderArr: ["SV1", "SV2", "S1", "S2", "S3", "S4", "S5", "S6", "S7", "S8"]
  },

  mutations: {
    clearAll(state) {
      state.currentMode = "origin";
      state.directMotors = {};
      state.servoMotors = {};
      state.selectedMotor = { key: "", type: "" };
      state.openedMotor = { key: "", type: "" };
    },
    createDirectMotor(state, { key = "", value = "" }) {
      Vue.set(state.directMotors, key, value);
      console.log(state.directMotors);
    },
    createServoMotor(state, { key = "", value = "" }) {
      Vue.set(state.servoMotors, key, value);
    },
    selectMotor(state, { key = "", type = "" }) {
      state.selectedMotor = { key, type };
    },
    setDragging(state, boolean) {
      state.isDragging = boolean;
    },
    openMotor(state, { key = "", type = "" }) {
      state.openedMotor = { key, type };
    },
    closeMotor(state) {
      state.openedMotor = { key: "", type: "" };
    },
    changeMotor(state, { key = "", type = "", theProp = "", value = "" }) {
      switch (type) {
        case "directMotor":
          state["directMotors"][key][theProp] = value;
          break;
        case "servoMotor":
          state["servoMotors"][key][theProp] = value;
          break;
      }
    },
    changeBlockByDraggable(state, blocks) {
      state.blocks = blocks;
    },
    changeGroupBlockByDraggable(state, blocks) {
      state.blocks[state.currentGroupIndex].groupBlocks = blocks;
    },

    removeBlockManually(state, id) {
      // 砍完一整個group時候 觸發
      let indexToRemove = state.blocks.findIndex(block => block.id === id);
      if (indexToRemove === -1) {
        return;
      }
      state.currentGroupIndex = 0;
      state.modes.hasTimeline = "none";

      state.blocks.splice(indexToRemove, 1);
    },

    setCurrentGroupIndex(state, index) {
      state.currentGroupIndex = index;
    },

    toStatus(state, status = "") {
      //hasTimeline 分為 n 種 => none,inGroup,grouping...
      // console.log("toStatus", status);
      state.modes.hasTimeline = status;
    },
    setCurrentBlockMutation(state, block) {
      console.log("setCurrentBlockMutation");
      state.currentBlock = block;
    },
    changeCurrentBlockProp(state, { key, val }) {
      if (key === "time") {
        if (val >= state.MAX_TIME) {
          val = state.MAX_TIME;
        } else if (val <= state.MIN_TIME) {
          val = state.MIN_TIME;
        }
      }
      state.currentBlock[key] = val;
    },
    changeGroupBlockProp(state, { groupblock, key, val }) {
      let { id } = groupblock;
      let target = state.blocks.find(e => e.id === id);
      target.groupBlocks[key] = val;
    },
    createSingleBlockToGroup(state, { getters, block }) {
      let indexOfBlocks = getters.targetGroupMapBlocksIndex;
      state.blocks[indexOfBlocks].groupBlocks.push(block);
    },
    createSingleBlockToBlocks(state, { block }) {
      state.blocks.push(block);
    },
    removeSingleBlockToGroup(state, { getters, index }) {
      let indexOfBlocks = getters.targetGroupMapBlocksIndex;
      state.blocks[indexOfBlocks].groupBlocks.splice(index, 1);
    },
    removeSingleBlockToBlocks(state, { index }) {
      state.blocks.splice(index, 1);
    },
    transformSingleToCombinedStep2(state, { indexBegin, indexEnd, getters }) {
      let id = new Date().getTime();
      let count = indexEnd - indexBegin + 1;
      let getBlocks = state.blocks.splice(indexBegin, count);
      let groupNameMaker = getters => {
        let usedNames = getters.groups.map(group => group.groupName);
        let usefulNames = usedNames.filter(name => testRegex(name));
        let usefulNumbers = usefulNames.map(name => Number(name.match(/[1-9][0-9]{0,2}/))).sort();
        let result = 999;
        let exceptIndex = usefulNumbers.findIndex((value, index) => value !== index + 1);
        if (exceptIndex === -1) {
          result = usefulNumbers.length + 1;
        } else {
          result = exceptIndex + 1;
        }
        return `Group${result}`;

        function testRegex(str) {
          let re = new RegExp("^Group[1-9][0-9]{0,2}$");
          return re.test(str);
        }
      };
      let groupName = groupNameMaker(getters);

      state.blocks.splice(indexBegin, 0, {
        // 計算 blocks 總秒數的做法
        get time() {
          return this.groupBlocks
            ? this.groupBlocks.reduce((accumulator, block) => {
                return Number(block.time) + accumulator;
              }, 0)
            : this._time_;
        },
        set time(val) {
          this._time_ = val;
        },
        type: "group",
        id,
        isGroup: true,
        groupBlocks: getBlocks,
        groupName
      });
    }
  },
  actions: {
    setCurrentBlock({ state, getters, commit }, { id }) {
      let currentBlock;
      if (getters.currentMode === "inGroup") {
        // console.log(" getters.targetGroup", getters.targetGroup);
        currentBlock = getters.targetGroup.groupBlocks.find(block => block.id === id);
      } else {
        currentBlock = state.blocks.find(block => block.id === id);
      }
      commit("setCurrentBlockMutation", currentBlock);
    },
    createSingleBlock({ commit, getters }, { time = 0.5, type }) {
      let id = new Date().getTime();
      let block;
      //type 分為 act,stop,group
      if (getters.currentMode === "inGroup") {
        block = { time, type, id, isGroup: false };
        commit("createSingleBlockToGroup", { getters, block });
      } else {
        block = { time, type, id, isGroup: false };
        commit("createSingleBlockToBlocks", { block });
      }
    },

    removeBlockCurrent({ state, getters, commit }) {
      let { id } = state.currentBlock;
      let indexToRemove = 0;
      if (getters.currentMode === "inGroup") {
        indexToRemove = getters.targetGroup.groupBlocks.findIndex(block => block.id === id);
        if (indexToRemove === -1) {
          return;
        }
        commit("removeSingleBlockToGroup", { getters, index: indexToRemove });
      } else {
        indexToRemove = state.blocks.findIndex(block => block.id === id);
        if (indexToRemove === -1) {
          return;
        }
        commit("removeSingleBlockToBlocks", { index: indexToRemove });
      }
    },
    transformSingleToCombined({ getters, commit }, { indexBegin, indexEnd }) {
      commit("transformSingleToCombinedStep2", { indexBegin, indexEnd, getters });
    },
    checkNextDCMotorType({ state, getters }) {
      let DCMotorType = "";
      for (let DCMotorTypeName of state.DCMotorTypeOrderArr) {
        if (!getters[`${DCMotorTypeName}Used`]) {
          DCMotorType = DCMotorTypeName;
          break;
        }
      }
      // 下個可用type 回傳字串 ""代表沒有
      return DCMotorType;
    },
    checkNextSVMotorType({ state, getters }) {
      let SVMotorType = "";
      for (let SVMotorTypeName of state.SVMotorTypeOrderArr) {
        if (!getters[`${SVMotorTypeName}Used`]) {
          SVMotorType = SVMotorTypeName;
          break;
        }
      }
      // 下個可用type 回傳字串 ""代表沒有
      return SVMotorType;
    }
  },
  getters: {
    currentMode: state => {
      return state.blocks.length === 0 ? state.modes.basic : state.modes.hasTimeline;
    },
    groups: state => {
      let id = 777;

      let subGroup = state.blocks
        .filter(block => block.isGroup)
        .sort((blockA, blockB) => blockA.id - blockB.id)
        .map((block, index) => {
          return { id: block.id, active: state.currentGroupIndex === index + 1, groupName: block.groupName, groupBlocks: block.groupBlocks };
        });
      return [{ id, active: state.currentGroupIndex === 0, groupName: "main", groupBlocks: [...state.blocks] }, ...subGroup];
    },
    targetGroup: (state, getters) => {
      let target;
      if (getters.groups[state.currentGroupIndex]) {
        target = getters.groups[state.currentGroupIndex];
      } else {
        state.currentGroupIndex = 0;
        state.modes.hasTimeline = "none";
        target = getters.groups[state.currentGroupIndex];
      }
      return target;
    },
    targetGroupMapBlocksIndex: (state, getters) => {
      let { id } = getters.targetGroup;
      return state.blocks.findIndex(e => e.id === id);
    },

    EM2Used: state => {
      let directMotorsArr = Object.values(state.directMotors);
      let DCMotorTypeArr = directMotorsArr.map(e => e.DCMotorType);
      return DCMotorTypeArr.find(e => e === "EM2");
    },
    DC1Used: state => {
      let directMotorsArr = Object.values(state.directMotors);
      let DCMotorTypeArr = directMotorsArr.map(e => e.DCMotorType);
      return DCMotorTypeArr.find(e => e === "DC1");
    },
    DC2Used: state => {
      let directMotorsArr = Object.values(state.directMotors);
      let DCMotorTypeArr = directMotorsArr.map(e => e.DCMotorType);
      return DCMotorTypeArr.find(e => e === "DC2");
    },
    EM1Used: state => {
      let directMotorsArr = Object.values(state.directMotors);
      let DCMotorTypeArr = directMotorsArr.map(e => e.DCMotorType);
      return DCMotorTypeArr.find(e => e === "EM1");
    },
    SV1Used: state => {
      let servoMotorsArr = Object.values(state.servoMotors);
      let SVMotorTypeArr = servoMotorsArr.map(e => e.SVMotorType);
      return SVMotorTypeArr.find(e => e === "SV1");
    },
    SV2Used: state => {
      let servoMotorsArr = Object.values(state.servoMotors);
      let SVMotorTypeArr = servoMotorsArr.map(e => e.SVMotorType);
      return SVMotorTypeArr.find(e => e === "SV2");
    },
    S1Used: state => {
      let servoMotorsArr = Object.values(state.servoMotors);
      let SVMotorTypeArr = servoMotorsArr.map(e => e.SVMotorType);
      return SVMotorTypeArr.find(e => e === "S1");
    },
    S2Used: state => {
      let servoMotorsArr = Object.values(state.servoMotors);
      let SVMotorTypeArr = servoMotorsArr.map(e => e.SVMotorType);
      return SVMotorTypeArr.find(e => e === "S2");
    },
    S3Used: state => {
      let servoMotorsArr = Object.values(state.servoMotors);
      let SVMotorTypeArr = servoMotorsArr.map(e => e.SVMotorType);
      return SVMotorTypeArr.find(e => e === "S3");
    },
    S4Used: state => {
      let servoMotorsArr = Object.values(state.servoMotors);
      let SVMotorTypeArr = servoMotorsArr.map(e => e.SVMotorType);
      return SVMotorTypeArr.find(e => e === "S4");
    },
    S5Used: state => {
      let servoMotorsArr = Object.values(state.servoMotors);
      let SVMotorTypeArr = servoMotorsArr.map(e => e.SVMotorType);
      return SVMotorTypeArr.find(e => e === "S5");
    },
    S6Used: state => {
      let servoMotorsArr = Object.values(state.servoMotors);
      let SVMotorTypeArr = servoMotorsArr.map(e => e.SVMotorType);
      return SVMotorTypeArr.find(e => e === "S6");
    },
    S7Used: state => {
      let servoMotorsArr = Object.values(state.servoMotors);
      let SVMotorTypeArr = servoMotorsArr.map(e => e.SVMotorType);
      return SVMotorTypeArr.find(e => e === "S7");
    },
    S8Used: state => {
      let servoMotorsArr = Object.values(state.servoMotors);
      let SVMotorTypeArr = servoMotorsArr.map(e => e.SVMotorType);
      return SVMotorTypeArr.find(e => e === "S8");
    }
  }
};

export default ras;
